import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import { toast } from "react-toastify";
import { PageResponse } from "app/common/Model/Shared";
import {
  pagingSync,
} from "app/services/ServiceRequestItemService";
import { syncTreament } from "app/services/SyncCRMService";

export default class TreatmentAsyncStore {
  searchTreatmentListAll = {
    ...new SearchObject(),
    fromLastDateSync: new Date(new Date().setMonth(new Date().getMonth() - 1)),
    toLastDateSync: new Date(),
    departmentId: null,
    isSyncedToCRM: false,
  };
  pageTreatmentListAll = new PageResponse();
  selectTrementAsync = [];
  resetSelectedRows = false;

  constructor() {
    makeAutoObservable(this);
  }

  pagingTreatmentListAll = async () => {
    const { departmentId, performerId, roomId, healthCareSvId, ...ortherData } =
      this.searchTreatmentListAll;
    if (departmentId) {
      ortherData.departmentId = departmentId?.id;
    }

    if (performerId) {
      ortherData.performerId = performerId?.id;
    }

    if (roomId) {
      ortherData.roomId = roomId?.id;
    }
    if (healthCareSvId) {
      ortherData.healthCareSvId = healthCareSvId?.id;
    }
    return await pagingSync({ ...ortherData })
      .then(({ data }) => {
        this.pageTreatmentListAll = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu điều trị có lỗi");
      });
  };

  handleChangeFormSearch = (searchTreatmentListAll) => {
    this.searchTreatmentListAll = {
      ...this.searchTreatmentListAll,
      ...searchTreatmentListAll,
    };
    this.pagingTreatmentListAll();
  };

  setSelectTreamentAsync = (list) => {
    this.selectTrementAsync = list;
  };

  syncListTrementToCrm = async () => {
    const trementIds = this.selectTrementAsync?.map((el) => el?.id);
    this.resetSelectedRows = !this.resetSelectedRows;

    return await syncTreament(trementIds)
      .then(({ data }) => {
        this.resetSelectedRows = !this.resetSelectedRows;
        this.selectPatientAsync = [];
        if (data) {
          toast.success("Đồng bộ điều trị thành công");
          this.pagingTreatmentListAll();
        } else {
          toast.error("Đồng bộ điều trị có lỗi");
        }
      })
      .catch((error) => {
        this.resetSelectedRows = !this.resetSelectedRows;
        this.selectPatientAsync = [];
        console.error(error);
        toast.error("Đồng bộ điều trị có lỗi");
      });
  };

  resetStore = () => {
    this.searchTreatmentListAll = {
      ...new SearchObject(),
      fromLastDateSync: new Date(),
      toLastDateSync: new Date(new Date().setMonth(new Date().getMonth() - 1)),
    };
    this.pageTreatmentListAll = new PageResponse();
  };
}
